// Components
import { Textarea } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import type { PatientFormData } from "@benchmark/core/types";
import styles from "./PatientSummarySection.module.css";

/**
 * Props for the patient summary section.
 * @agentic connections
 */
type PatientSummarySectionProps = {
  form: UseFormReturnType<PatientFormData>;
};

/**
 * Patient summary textarea for the create/edit form.
 * @agentic connections
 */
export const PatientSummarySection = ({ form }: PatientSummarySectionProps) => (
  <Textarea
    label="Patient Summary"
    description="Brief overview for clinicians (1-2 sentences recommended)"
    placeholder="e.g., Patient is a 45-year-old with history of depression, currently stable on medication. Prefers afternoon appointments."
    minRows={2}
    maxRows={4}
    autosize
    {...form.getInputProps("summary")}
    classNames={{ root: styles.summaryField }}
  />
);
